import { z } from "zod";
export const UserRoleEnum = z.enum([
  "ADMIN",
  "MANAGER",
  "SUPERVISOR",
  "SERVER",
  "USER",
]);
export const AccountStatusEnum = z.enum([
  "CREATED",
  "UNVERIFIED",
  "ACTIVE",
  "SUSPENDED",
  "LOCKED",
]);
// Schema for user search/filter params
export const UserFilterSchema = z.object({
  page: z.number().default(1),
  limit: z.number().default(10),
  orderBy: z
    .enum(["firstName", "lastName", "email", "role", "createdAt"])
    .default("createdAt"),
  orderDirection: z.enum(["asc", "desc"]).default("desc"),
  search: z.string().optional(),
  role: UserRoleEnum.optional(),
  status: AccountStatusEnum.optional(),
});
// Schema for user in lists
export const UserListItemSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  role: UserRoleEnum,
  accountStatus: AccountStatusEnum,
  mfaEnabled: z.boolean(),
  isActive: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
  lastLoginAt: z.date().nullable(),
});
// Schema for detailed user
export const UserDetailSchema = UserListItemSchema.extend({
  mfaType: z.string().nullable(),
  pendingEmail: z.string().nullable().optional(),
});
// Schema for user list response with pagination
export const PaginationSchema = z.object({
  page: z.number(),
  limit: z.number(),
  totalCount: z.number(),
  totalPages: z.number(),
  hasMore: z.boolean(),
});
export const UserListResponseSchema = z.object({
  users: z.array(UserListItemSchema),
  pagination: PaginationSchema,
});
// Create User Schema
export const CreateUserSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Invalid email format"),
  password: z.string().min(8, "Password must be at least 8 characters"),
  role: UserRoleEnum,
  mfaEnabled: z.boolean().default(false),
  mfaType: z.string().optional(),
});
// Update User Schema
export const UpdateUserSchema = z.object({
  id: z.string(),
  firstName: z.string().min(1, "First name is required").optional(),
  lastName: z.string().min(1, "Last name is required").optional(),
  email: z.string().email("Invalid email format").optional(),
  role: UserRoleEnum.optional(),
  accountStatus: AccountStatusEnum.optional(),
  mfaEnabled: z.boolean().optional(),
});
// Reset User Password Schema
export const ResetUserPasswordSchema = z.object({
  id: z.string(),
  password: z.string().min(8, "Password must be at least 8 characters"),
});
